<template>
  <span>
    <span v-if="all" class="ti-tag" :class="styleClasses">
      {{ label }}: ALL
    </span>
    <template v-else v-for="item in items">
      <span :key="item" class="ti-tag" :class="styleClasses"
            :title="label">
        <!-- TODO: name_map for VERTICAL & TECH: name_map[item] -->
        {{item}}
      </span>
    </template>
  </span>
</template>

<script>

export default {
  name: 'TransformaTags',
  props: {
    label: { type: String, required: true },
    all: { type: Boolean, default: false },
    items: { type: Array },
    extraClass: { type: String, required: false },
    low: { type: Boolean, default: false }, // background with opacity
    small: { type: Boolean, default: false },
  },
  computed: {
    styleClasses() {
      const classes = [];
      let base = `ti-tag-${this.label}`;
      if (this.low) {
        base += '-low';
      }
      classes.push(base);
      if (this.small) {
        classes.push('ti-tag-small');
      }
      if (this.extraClass) {
        classes.push(this.extraClass);
      }
      return classes;
    },
  },
};
</script>

<style scoped>
</style>
